<template>
  <div id="app">
    <b-alert
      v-model="showAlert"
      auto-hide-delay
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000"
      :variant="alertColor"
      >{{ alertMessage }}</b-alert
    >
    <navigation @showAlert="showAlertMessage"></navigation>
    <div>
      <loading :active.sync="showLoadingModal" :can-cancel="false"></loading>
      <router-view
        v-if="this.isLoaded"
        @showAlert="showAlertMessage"
        :isLoading.sync="showLoadingModal"
      ></router-view>
    </div>
  </div>
</template>

<script>
import navigation from "./components/Layout/Navigation.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import auth from "@/auth.js";
import g from "@/interfaces/GlobalData.js";

export default {
  data() {
    return {
      user: null,
      showAlert: false,
      alertMessage: null,
      alertColor: null,
      showLoadingModal: false,
      timer: null,
      isLoaded: false,
    };
  },
  name: "App",
  components: {
    navigation,
    Loading,
  },
  async created() {
    document.addEventListener("swUpdated", this.updateAvailable, {
      once: true,
    });
    this.environment = process.env.VUE_APP_MODE;
    await this.refreshUser();

    this.isLoaded = true;

    this.timer = setInterval(this.refreshToken, 1000 * 60 * 15);
  },
  computed: {
    hasUser() {
      return this.user !== null;
    },
  },
  methods: {
    showAlertMessage(object) {
      this.showAlert = true;
      this.alertMessage = object.message;
      this.alertColor = object.color ?? "success";

      setTimeout(() => (this.showAlert = false), 5000);
    },
    async refreshToken() {
      var bearerToken = `bearer ${await auth.acquireToken()}`;

      this.$axios.defaults.headers.common = {
        Authorization: `${bearerToken}`,
      };

      console.log("Refresh token success");
    },
    async refreshUser() {
      this.user = await g.getUserProfile();
      await g.getUserPhoto();
    },
  },
  watch: {
    $route: {
      immediate: true,
      async handler(to, from) {
        if ((from != null || from != undefined) && from.name === "signin") {
          this.refreshUser();
        }
      },
    },
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}

body {
  padding-top: 80px;
  padding-bottom: 56px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

* {
  box-sizing: border-box;
}

#app {
  color: #2c3e50;
}

.popover {
  max-width: 500px !important;
  width: 320px !important;
}
</style>
